import { render, staticRenderFns } from "./SplitBox.vue?vue&type=template&id=4f455406&scoped=true"
import script from "./SplitBox.vue?vue&type=script&lang=js"
export * from "./SplitBox.vue?vue&type=script&lang=js"
import style0 from "./SplitBox.vue?vue&type=style&index=0&id=4f455406&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f455406",
  null
  
)

export default component.exports